import { useSelector } from 'react-redux';
import { SETTINGS_FILTERS } from 'utils/constants';
import { selectUserId } from 'state/User/userSlice';
import { useProjectTasksTable } from '../hooks/useProjectTasksTable';
import TasksTable from '../TasksTable/TasksTable';
import ActionsNotificationsList from 'Pages/TaskDetailPage/ActualHoursModal/ActionsNotificationsList/ActionsNotificationsList';

const UserTasks = () => {
  const userId = useSelector(selectUserId);

  const {
    tasks,
    canFetchMoreTasks,
    totalCount,
    filters,
    isLoading,
    handleFetchMoreTasks,
    handleUpdateFilters,
    handleSearchFilterChange,
    handleExportTasks,
    SnackbarNotification,
    isNotificationVisible,
    snackbarProps,
    hasAppliedFilters,
    refreshTasks,
  } = useProjectTasksTable({
    tableType: SETTINGS_FILTERS.MY_PROJECT_TASKS_TABLE,
    userId,
  });

  return (
    <>
      <TasksTable
        tableName={SETTINGS_FILTERS.MY_PROJECT_TASKS_TABLE}
        tasks={tasks}
        canFetchMoreTasks={canFetchMoreTasks}
        fetchMoreTasks={handleFetchMoreTasks}
        totalCount={totalCount}
        filters={filters}
        onUpdateFilters={handleUpdateFilters}
        onSearchFilterChange={handleSearchFilterChange}
        onExport={handleExportTasks}
        refreshTasks={refreshTasks}
        isLoading={isLoading}
        hasAppliedFilters={hasAppliedFilters}
      />
      <ActionsNotificationsList />

      {isNotificationVisible && snackbarProps && (
        <SnackbarNotification {...snackbarProps} />
      )}
    </>
  );
};

export default UserTasks;
